import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  {
    path: '/tableauviz',
    name: 'tableauviz',
    component: () => import(/* webpackChunkName: "about" */ '../views/TableauVizView.vue')
  },
  {
    path: '/tableauvizformgmt',
    name: 'tableauvizformgmt',
    component: () => import(/* webpackChunkName: "about" */ '../views/TableauVizViewForMGMT.vue')
  },
  {
    path: '/tableauvizforns',
    name: 'tableauvizforns',
    component: () => import(/* webpackChunkName: "about" */ '../views/TableauVizViewForNS_2.vue')
  },
  {
    path: '/tableauvizforparts',
    name: 'tableauvizforparts',
    component: () => import(/* webpackChunkName: "about" */ '../views/TableauVizViewForParts_2.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
